package com.xtream.composeapp.presentation.ui.navigation.data

import androidx.compose.ui.graphics.vector.ImageVector
import androidx.navigation3.runtime.NavKey
import com.xtream.composeapp.data.Screen
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

sealed interface NavIcon {

    data class Resource(
        val res: DrawableResource
    ) : NavIcon

    data class Vector(
        val imageVector: ImageVector
    ) : NavIcon
}
data class NavigationItem(
    val title: StringResource,
    val icon: NavIcon,
    val route:  Screen
): NavKey